import psychiatryQuestionSet from "../faq/psychiatryQuestionSet";

export const mikolajKlosowski = {
    'firstName': 'Mikołaj',
    'lastName': 'Kłosowski',
    'mydrId': 'mikołajkłosowski',
    'profession': 'Lekarz rezydent psychiatrii',
    'avatar': 'mikolaj-klosowski.webp',
    'slug': 'psychiatra-rezydent-mikolaj-klosowski',
    'locations': ['bydgoszcz'],
    'services': [
        ['psychiatry', 'adult'],
    ]
}